import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setCurrentPage } from '../../../store/BookSlice';
import { Button } from '../../_atoms/Button';
import { Input } from '../../_atoms/Input';
import { ImageButton } from '../../_molecules/ImageButton';

const Wrap = styled.div`
  position: absolute;
  top: 984px;
  left: 1531px;
  z-index: 2;
  width: 210px;
  height: 60px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PageBox = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PageWrap = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const [value, setValue] = useState(state.book.current_page);

  useEffect(() => {
    setValue(state.book.current_page);
  }, [state.book.current_page]);

  const onPrevButton = () => {
    const index = state.book.bookInfo.page.findIndex((page) => page === state.book.current_page);
    dispatch(setCurrentPage(index !== 0 ? state.book.bookInfo.page[index - 1] : state.book.current_page));
  };

  const onNextButton = () => {
    const index = state.book.bookInfo.page.findIndex((page) => page === state.book.current_page);
    dispatch(setCurrentPage(index !== state.book.bookInfo.page.length - 1 ? state.book.bookInfo.page[index + 1] : state.book.current_page));
  };

  const onPageChange = (e) => {
    setValue(e.target.value);
  };

  const onPageSearch = (e) => {
    if (e.keyCode === 13) {
      const pages = state.book.bookInfo.page.filter((page) => page.includes(e.target.value));
      pages.length > 0 ? dispatch(setCurrentPage(pages[0])) : setValue(state.book.current_page);
    }
  };

  const onPageGo = () => {
    const pages = state.book.bookInfo.page.filter((page) => page.includes(value));

    if (pages.length > 0) {
      dispatch(setCurrentPage(pages[0]));
      setValue(pages[0]);
    } else {
      setValue(state.book.current_page)
    }
  };

  return (
    <Wrap>
      <PageBox>
        <ImageButton
          src='https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/pagenation_pre.png'
          alt='pre'
          type='page'
          onClick={() => onPrevButton()}
        />
        <Input 
          type='text'
          name='page'
          value={value}
          className='page'
          onChange={onPageChange}
          onKeyDown={onPageSearch}
        />
        <ImageButton 
          src='https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/pagenation_next.png'
          alt='next'
          type='page'
          onClick={() => onNextButton()}
        />
      </PageBox>
      <Button type="go" onClick={() => onPageGo()}>Go</Button>
    </Wrap>
  );
};